var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

import * as React from 'react';
import { UIDFork, UIDConsumer } from "react-uid";
import { PrerenderedControls } from "./PrerenderedControl";

var getInnerHTML = function getInnerHTML(id) {
  var element = typeof document !== 'undefined' && document.getElementById(id);
  return element ? element.innerHTML : null;
};

var PrerenderedWrapper = function (_super) {
  __extends(PrerenderedWrapper, _super);

  function PrerenderedWrapper() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      html: getInnerHTML(_this.props.id)
    };
    return _this;
  }

  PrerenderedWrapper.prototype.componentDidMount = function () {
    var _a = this.props,
        live = _a.live,
        dehydrate = _a.dehydrate,
        id = _a.id;

    if (!live) {
      var element = document.getElementById(id);

      if (element) {
        dehydrate(element);
      }
    }
  };

  PrerenderedWrapper.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        live = _a.live,
        strict = _a.strict,
        id = _a.id,
        className = _a.className,
        style = _a.style;
    var html = this.state.html;
    var props = {
      id: id,
      className: className,
      style: style,
      'data-prerendered-border': true
    };
    return live || !html && !strict ? React.createElement("div", __assign({}, props), children) : React.createElement("div", __assign({}, props, {
      dangerouslySetInnerHTML: {
        __html: html || ''
      }
    }));
  };

  return PrerenderedWrapper;
}(React.Component);

var isBooleanFlag = function isBooleanFlag(flag) {
  return !flag || typeof flag === 'boolean' || !flag.then;
};

var PrerenderedComponent = function (_super) {
  __extends(PrerenderedComponent, _super);

  function PrerenderedComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      state: null,
      live: false
    };
    _this.awaitingFor = undefined;

    _this.dehydrate = function (el) {
      if (_this.props.restore) {
        var store = el.querySelector("script[type=\"text/store-" + el.id + "\"]");
        Promise.resolve(_this.props.restore(el, JSON.parse((store ? store.textContent : '') || '{}'))).then(function (state) {
          return _this.setState({
            live: true,
            state: state
          });
        });
      }
    };

    return _this;
  }

  PrerenderedComponent.getDerivedStateFromProps = function (props, state) {
    if (isBooleanFlag(props.live) && props.live !== state.live) {
      return {
        live: props.live
      };
    }

    return null;
  };

  PrerenderedComponent.prototype.componentDidMount = function () {
    this.checkLive();
  };

  PrerenderedComponent.prototype.componentDidUpdate = function () {
    this.checkLive();
  };

  PrerenderedComponent.prototype.checkLive = function () {
    if (!isBooleanFlag(this.props.live)) {
      this.awaitForLive(this.props.live);
    }
  };

  PrerenderedComponent.prototype.awaitForLive = function (live) {
    var _this = this;

    if (this.awaitingFor !== live) {
      this.awaitingFor = live;
      Promise.resolve(live).then(function (value) {
        return _this.props.live === live && _this.setState({
          live: !!value
        });
      });
    }
  };

  PrerenderedComponent.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        style = _a.style,
        children = _a.children,
        store = _a.store,
        _b = _a.strict,
        strict = _b === void 0 ? false : _b;
    var live = this.state.live;
    return React.createElement(PrerenderedControls, null, function (_a) {
      var isServer = _a.isServer;
      return React.createElement(UIDFork, null, React.createElement(UIDConsumer, null, function (uid) {
        return React.createElement(PrerenderedWrapper, {
          id: "prc-" + uid,
          className: className,
          style: style,
          live: !!(live || isServer),
          strict: strict,
          dehydrate: _this.dehydrate
        }, store && React.createElement("script", {
          type: "text/store-prc-" + uid,
          dangerouslySetInnerHTML: {
            __html: JSON.stringify(store)
          }
        }), children);
      }));
    });
  };

  return PrerenderedComponent;
}(React.Component);

export { PrerenderedComponent };